export function formatUnreadMessagesLabel(count, fallback = 'Row actions') {
  const unread = Number(count) || 0;
  if (unread <= 0) return fallback;
  return `${unread} unread message${unread === 1 ? '' : 's'}`;
}
